export default __webpack_public_path__ + "static/media/empty-address.6de0bd2f.svg";